import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../enterprise.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-employee-requests",
  templateUrl: "./employee-requests.component.html",
  styleUrls: ["./employee-requests.component.sass"],
})
export class EmployeeRequestsComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private enterpriseService: EnterpriseService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  page: number = 1;
  itemsPerPage: number = 5;
  totalItems: number = 0;

  selectedTab: number = 1;

  enterpriseRequests: any[] = [];

  // ---------- Change Tab ----------
  changeTab(tab: number) {
    this.selectedTab = tab;
    this.page = 0; // reset page when changing tabs
    this.getAllEnterpriseEmployeeRequests();
  }

  // ---------- Get Requests ----------
  getAllEnterpriseEmployeeRequests() {
    this.spinner.show();

    let data = {
      page: this.page,
      limit: this.itemsPerPage,
      status: this.selectedTab,
    };

    this.enterpriseService.getEntpEmployeeRequests(data).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode == 200) {
          this.enterpriseRequests = result.data;
          this.totalItems = result.pagination?.total;
        } else {
          this.toastr.error(result.message);
          this.enterpriseRequests = [];
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  // ---------- Pagination ----------
  gty(page) {
    this.page = page;
    this.getAllEnterpriseEmployeeRequests();
  }

  updateRequest(id: any, status: number) {
    this.spinner.show();
    let data = {
      status: status,
    };
    this.enterpriseService.approveRejectEntpEmployeeRequest(id, data).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode == 200) {
          this.toastr.success(result.message);
          this.spinner.hide();
          this.getAllEnterpriseEmployeeRequests();
        } else {
          this.toastr.error(result.message);
          this.enterpriseRequests = [];
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }
}
